// removed by extract-text-webpack-plugin
module.exports = {"plan-price":"plan-price","plan-price-currency":"plan-price-currency","plan-price-integer-part":"plan-price-integer-part","plan-price-fractional-part":"plan-price-fractional-part"};


//////////////////
// WEBPACK FOOTER
// ./src/common/component/plans/component/plan/component/plan-price/plan-price.style.sass
// module id = zT7+
// module chunks = 3